/**
 * StatChip + STAT_TONES
 *
 * The little icon + count + label pill used in the AI-import impact summaries
 * (Review step, BatchApplyDialog). Extracted here so the two call sites share
 * one implementation; can later graduate into the ui kit as a StatTile primitive.
 */

import { type ElementType } from 'react';
import { cn } from '@/lib/utils';

export const STAT_TONES = {
  emerald: 'border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300',
  amber: 'border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
  // Navy, not the ember brand: this chip sits beside the `amber` one.
  primary: 'border-navy-200 bg-navy-50 text-navy-700 dark:border-navy-800 dark:bg-navy-900/40 dark:text-navy-200',
  slate: 'border-gray-200 bg-white text-gray-600 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400',
} as const;

export function StatChip({
  icon: Icon,
  value,
  label,
  tone,
}: {
  icon: ElementType;
  value: number;
  label: string;
  tone: keyof typeof STAT_TONES;
}) {
  return (
    <div className={cn('flex items-center gap-2 rounded-xl border px-3 py-2 shadow-sm', STAT_TONES[tone])}>
      <Icon className="h-4 w-4 opacity-80" />
      <span className="text-lg font-bold tabular-nums leading-none">{value}</span>
      <span className="text-xs font-medium leading-tight">{label}</span>
    </div>
  );
}
